module.exports = __webpack_public_path__ + "img/6f672e7.svg";